<template>
  <div>
    <Header
      v-if="
        $store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
      "
      :window="window"
      :parameters="'adminPage'"
    />
    <div
      :class="
        $store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
          ? window.width < 480
            ? 'container-fluid'
            : 'container'
          : 'p-3'
      "
    >
      <!-- <ButtonReturnColidee
        v-if="
          $store.state.authentification.connectUserEmail ===
            'colidee@colidee.com' && adminActiveComponents.parameters
        "
        :adminComponent="true"
      /> -->
      <SearchBar v-if="adminActiveComponents.searchBar" />
      <CardsList :window="window" v-if="adminActiveComponents.cardList" />
      <br />
      <Parameters v-if="adminActiveComponents.parameters" />
      <div class="white_space_200"></div>
    </div>
    <br><br><br><br><br><br>
    <Footer
      v-if="
        $store.state.authentification.connectUserEmail !== 'colidee@colidee.com'
      "
      :window="window"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'
import CardsList from '@/components/insight/PageAdmin/CardsList'
import Parameters from '@/components/insight/PageAdmin/Parameters'
import SearchBar from '@/components/insight/PageAdmin/components/SearchBar'
import ButtonReturnColidee from '@/components/insight/Buttons/ButtonReturnColidee'
export default {
  name: 'Admin',
  components: {
    Header,
    Footer,
    CardsList,
    Parameters,
    SearchBar,
    ButtonReturnColidee
  },
  data () {
    return {
      window: {
        width: window.innerWidth
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  mounted () {
    this.$nextTick(() => {
      this.handleResize()
    })
  },
  computed: {
    ...mapGetters(['adminActiveComponents']),
  },
  updated () {
    this.sendMessageToParent('scrollToTop')
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    handleResize () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
      this.window.width = window.innerWidth
    }
  }
}
</script>
<style scoped>
.white_space_200{
  height:200px;
}
</style>
